import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledBtnConfirm } from './styles/StyledBtnConfirm';

class BtnConfirm extends Component {
  render() {
    const { title, handleOnCLick, isEnabled } = this.props;

    const enabled = isEnabled ? 'enabled' : 'disabled'

    return (
      <StyledBtnConfirm
          disabled={enabled === 'enabled' ? false : true}
          onClick={isEnabled ? handleOnCLick : ''}
      >
          <span className="btn-confirm-title">
            { title }
          </span>
      </StyledBtnConfirm>
    );
  }
}


BtnConfirm.propTypes = {
  title: PropTypes.string.isRequired,
  isEnabled: PropTypes.bool.isRequired,
  handleOnCLick: PropTypes.func.isRequired,
};


export default BtnConfirm;


// WEBPACK FOOTER //
// ./src/common/BtnConfirm/BtnConfirm.js